/* Vue.js application setup with toast notifications and dynamic component registration. */
import Toast, { useToast } from "vue-toastification";

/* COMPONENT IMPORT */
import Counter from "./components/Counter.vue";
import ColorChanger from "./components/ColorChanger.vue";

class vueApp {

    app = null;

    /* External component registration */
    components = {
        Counter, ColorChanger
    }

    initApp() {
        this.app = Vue.createApp();
    }

    mount(selector) {

        /* Default configuration for toast notifications */
        const toastOptions = {
            position: "top-center",
            timeout: 2000,
            closeOnClick: true,
            pauseOnFocusLoss: false,
            pauseOnHover: false,
            draggable: false,
            draggablePercent: 0.6,
            showCloseButtonOnHover: true,
            hideProgressBar: false,
            closeButton: "button",
            icon: true,
            rtl: false
        };

        this.app.use(Toast, toastOptions);

        this.app.mount(selector);
    }

    /* Utility method to show toast notifications */
    toastMessage(text, type) {
        const toast = useToast();

        switch (type) {
            case 'success':
                toast.success(text);
                break;
            case 'error':
                toast.error(text);
                break;
            case 'info':
                toast.info(text);
                break;
            case 'warning':
                toast.warning(text);
                break;
            case 'default':
                toast(text);
                break;
            default:
                toast(text);
                break;
        }
    }

    /* Utility method to register components dynamically */
    registerComponent(tag, template, component) {
        if (template) {
            component.template = template.innerHTML;
        }

        this.app.component(tag, component);

        var element = document.createElement(tag);

        if (template) {
            template.replaceWith(element);
        }
    }

    /* Utility method to resolve URLs, especially those starting with '~/'. This is useful for referencing static assets in a consistent way. */
    resolveUrl(url) {
        if (url.indexOf('~/') == 0) {
            return url.replace('~/', `${window.location.protocol}//${window.location.host}/`);
        }

        return url;
    }
}

window.vueApp = new vueApp(); //ensure access from our js